import {mdBreakpoint} from "../utils/breakpoints"
import { gsap } from 'gsap'

function initAccordions() {

  const accordions = Array.from(document.querySelectorAll('.js-accordion'))

  accordions.forEach(accordion => {

      const accordionItems = accordion.querySelectorAll('.js-accordion-item')

      accordionItems.forEach(accordionItem => {

        const accordionHeader = accordionItem.querySelector('.js-accordion-header')
        const accordionContent = accordionItem.querySelector('.js-accordion-content')
        let accordionItemsAnimated = false

        const animateAccordionItems = () => {

          if (accordion.classList.contains('-producer') && mdBreakpoint.matches) {

            accordionItemsAnimated = false

            if (accordionItemsAnimated === true) {
              accordionContent.kill()
            }

          } else {
            accordionItem.classList.toggle('-item-expanded')

            if (accordionItem.classList.contains('-item-expanded')) {
              gsap.fromTo(
                accordionContent, {
                  height: 0,
                },
                {
                  height: 'auto',
                }
              )
            } else if (!accordionItem.parentElement.classList.contains('-item-expanded')) {
              gsap.to(
                accordionContent, {
                  height: 0,
                }
              )
            }

            accordionItemsAnimated = true
          }
        }

        accordionHeader.addEventListener('click', animateAccordionItems)

        const resetAccordionContentHeight = () => {
          if (accordion.classList.contains('-producer') && mdBreakpoint.matches && accordionItemsAnimated === true) {
            accordionContent.style.height = null
            accordionItem.classList.remove('-item-expanded')
          }
        }

        const invokeAfterResize = () => {
          let rtime
          let timeout = false
          const timeoutDuration = 200

          window.addEventListener('resize', () => {
            rtime = new Date()
            if (timeout === false) {
              timeout = true
              setTimeout(resizeEnd, timeoutDuration)
            }
          })

          const resizeEnd = () => {
            if (new Date() - rtime < timeoutDuration) {
              setTimeout(resizeEnd, timeoutDuration)
            } else {
              timeout = false

              //Invoke after resize
              resetAccordionContentHeight()
            }
          }
        }

        //Invoke after resize event
        invokeAfterResize()
      })
  })
}
initAccordions()
